module.exports = __webpack_public_path__ + "static/media/light-switch.1108b785.svg";